import { Button, UserHelp, IndexPointingUpEmoji } from '@imedcl/design-system'
import { Annulment } from '../Icons/Anullment'
import { errDictionaty } from '../../helpers/dictionary'

export const FirstStep = ({
  onConfirmSend,
  loading,
  handleClose,
  email,
  error,
}) => {
  const maskEmail = (email = '') => {
    const [localPart = '', domainPart = ''] = String(email).split('@')
    if (!localPart || !domainPart) {
      return ''
    }
    const [domainName = '', tld = ''] = domainPart.split('.')
    const maskedLocal = `${localPart.slice(0, 3)}****`
    const maskedDomain = `${domainName.slice(0, 2)}****`
    return tld
      ? `${maskedLocal}@${maskedDomain}.${tld}`
      : `${maskedLocal}@${maskedDomain}`
  }

  return (
    <div>
      <h2 className='text-base font-bold text-center text-secondary-imed-60 mb-4 leading-6'>
        Confirmación de email y código de validación
      </h2>
      <p className='text-center text-base font-normal text-neutral-70 mb-6'>
        Para poder visualizar tus facturas enviaremos un código de validación a
        tu email {maskEmail(email)}.
      </p>
      <div className='-my-4'>
        <UserHelp
          colorStyle='warning'
          icon={<IndexPointingUpEmoji svgClass='h-8 w-8' />}
          customText={
            <p className='text-secondary-imed-60 text-sm'>
              En caso de requerir un cambio debe ser solicitado al siguiente
              e-mail: <span className='font-semibold'>cobranzas@imed.cl</span>
            </p>
          }
        />
      </div>
      {error && (
        <div className='mt-10'>
          <Annulment
            customHeight='56'
            customWidth='56'
            svgClass='mx-auto mb-3'
            pathClass='stroke-error-dark'
          />
          <p className='text-base font-normal leading-6 text-center text-error-dark w-[326px] mx-auto'>
            {errDictionaty[error] ?? error ?? 'Error en MFA'}
          </p>
        </div>
      )}
      <div className='flex justify-end mt-10 gap-6'>
        <Button
          buttonType='button'
          type='secondary-two'
          onClick={handleClose}
          disabled={loading}>
          Cancelar
        </Button>
        <Button
          buttonType='button'
          type='secondary'
          onClick={onConfirmSend}
          className='m-0'
          disabled={loading}
          loading={loading}>
          Confirmar envío
        </Button>
      </div>
    </div>
  )
}
